import React, { useState } from "react";
import { useStore } from "../../../helpers";
import { FormProvider, useForm } from "react-hook-form";
import { FTPInput } from "../../../components-new";
import { ProceedButton } from "./Buttons";
import useCMDFormFunctions from "./hooks/useCMDFormFunctions";
import { LoadingState } from "../../../components";
import { yupResolver } from "@hookform/resolvers/yup";
import { CMDFormValidationSchema } from "./hooks/schema";

const CMDForm = () => {
  const { setActiveAssignTaskTab, onError, onSubmit } = useCMDFormFunctions();
  const methods = useForm({
    defaultValues: {
      commands: null,
    },
    resolver: yupResolver(CMDFormValidationSchema),
  });
  const [loading, setLoading] = useState(false);
  if (loading) {
    return <LoadingState />;
  }
  return (
    <FormProvider {...methods}>
      <FTPInput
        label={"Phone Numbers"}
        name={`commands`}
        multiline
        placeholder={
          "ex - 99999999 (phone number) - 12 (booth number) - 10 (sample size)"
        }
        rows={10}
      />
      <br />
      <ProceedButton
        onClick={async () => {
          setLoading(true);
          await methods.handleSubmit(onSubmit, onError)();
          setLoading(false);
          setActiveAssignTaskTab("UI");
        }}
      />
    </FormProvider>
  );
};

export default CMDForm;
